import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';
import SectionHeading from '@/components/feature/SectionHeading';

export default function CategorySection() {
  return (
    <section id="categories" className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-50">
      <div className="mb-2">
        <SectionHeading
          eyebrow="按场景找坑"
          title="八大消费场景，逐一排雷"
          description="不同场景的坑长得不一样。先选你正准备的消费类型，直接看对应清单，比从头翻一遍更快。"
          linkTo="/guides"
          linkLabel="查看全部清单"
        />
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/guides?category=${cat.id}`}
            className="group relative flex flex-col rounded-lg border border-background-200 bg-background-100/50 p-5 hover:border-primary-300 hover:bg-primary-50/60 transition-colors"
          >
            <span className="w-11 h-11 rounded-md bg-background-50 border border-background-200 text-primary-600 flex items-center justify-center text-xl group-hover:bg-primary-500 group-hover:text-background-50 group-hover:border-primary-500 transition-colors">
              <i className={cat.icon}></i>
            </span>
            <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{cat.name}</h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed font-body flex-1">{cat.desc}</p>
            <div className="mt-4 flex items-center justify-between text-xs font-label text-foreground-500">
              <span>{cat.count} 份清单</span>
              <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-600 transition-colors"></i>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}